import React from 'react';
import proContact from '@core/ui/static/images/pro-contact.svg';

const ProContactIcon = ({ className }) => (
  <div className={className}>
    <img src={proContact} alt="pro-contact" width={610} height={500} />
  </div>
);

export default ProContactIcon;
